const formatMoney = number =>
	new Intl.NumberFormat("pl-PL", { style: "currency", currency: "USD" }).format(number).replace(/\D00(?=\D*$)/, "");

export default formatMoney;
export { formatMoney };
